import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { BaseView } from 'src/app/view/base-view';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { CitasApiService } from 'src/app/service/api/citas-api.service';
import { environment } from 'src/environments/environment';
import moment from 'moment';

import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { CitasModel } from 'src/app/models/citas/citas.model';
import { TreeNode } from 'primeng/api';

import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { VisitasConsultasListModalFormDefinition } from './form-control/list-modal-form-definition';
@Component({
    selector: 'app-visitas-consultas',
    standalone: false,
    templateUrl: './visitas-consultas.component.html',
    styleUrls: ['./visitas-consultas.component.scss']
})
export class VisitasConsultasComponent extends BaseView<CitasModel> implements OnInit {
    public form: VisitasConsultasListModalFormDefinition | null = null;
    public serverUrl = environment.serverUrl;
    public deleteRequest: RequestHandler<CitasModel> = new RequestHandler<CitasModel>();


    public showVisitasConsultasObservaciones = environment.features.showVisitasConsultasObservaciones;
    public hasClients = environment.features.hasClients;
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public showVisitasHora = environment.features.showVisitasHora;
    public hasVisitasHoraInicioFin = environment.features.hasVisitasHoraInicioFin;
    public clienteName = environment.features.clienteName;
    public showMotivo = environment.features.showMotivo;

    public getRequest: RequestHandler<CitasModel[]> = this.citasApi.citas.GET;
    public menuItemId = 'visitas-consultas';

    public cols: ColInterface[] = [
        {field: 'fecha', header: 'Fecha'},
        {field: 'hora', header: 'Hora', visible: this.showVisitasHora},
        {field: 'duracion', header: 'Duración', visible: this.hasVisitasHoraInicioFin},
        {field: 'cliente_nombre', header: this.clienteName, visible: this.hasClients},
        {field: 'finca_nombre', header: this.fincaName},
        {field: 'cultivo_nombre', header: 'Cultivo'},
        {field: 'variedad_nombre', header: 'Variedad'},
        {field: 'visitador_nombre', header: 'Visitador'},
        {field: 'motivo', header: 'Motivo', visible: this.showMotivo},
        {field: 'observaciones', header: 'Observaciones', visible: this.showVisitasConsultasObservaciones}
    ];

    constructor(private dashboard: DashboardService, private citasApi: CitasApiService) {
        super(dashboard, citasApi.citas.GET);
    }


    public override show(modal: string, data: CitasModel): void {
        super.show(modal, data);
        this.setModalForm(modal);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('visitas', this.menuItemId);
    }

    public globalConditionalStyle(_value: string, cell: ColInterface) {
        if (cell.header === 'Fecha'
        || cell.header === 'Hora'
        || cell.header === 'Visitador'
        || cell.header === 'Realizada'
        || cell.header === 'Duración') {

            return {
                textAlign: 'center'
            };
        }
        else {
            return {
                marginLeft: '40px;'
            };
        }
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<CitasModel>) {
        const cita = row.data as CitasModel;

        if (col.field === 'realizada') {
            return (value === '1') ? 'Sí' : 'No';
        }
        if ((col.field === 'duracion') && cita.visita && cita.visita.hora_inicio && cita.visita.hora_fin) {
            const fin = moment(cita.visita.hora_fin, 'HH:mm');
            const inicio = moment(cita.visita.hora_inicio, 'HH:mm');
            const diff = fin.subtract(inicio.get('hours'), 'hours').subtract(inicio.get('minutes'), 'minutes');
            return diff.format('HH:mm');
        } else {
            return value;
        }
    }
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new VisitasConsultasListModalFormDefinition(formType, this.model, this);
    }

}
